import type { ClaimCandidateStatus, Forum } from "@hp/types";

export const CLAIM_CANDIDATE_STATUSES: ClaimCandidateStatus[] = [
  "identified",
  "validated",
  "filed",
  "allowed",
  "recovered",
  "rejected",
  "deferred",
];

export const FORUMS: Forum[] = [
  "state_commission",
  "appellate_tribunal",
  "central_tribunal",
  "supreme_court",
  "central_ministry",
];

/**
 * The real issue-tag vocabulary the extraction pipeline's own issue
 * detection actually assigns (see `extraction/issue_detection.py`'s
 * `ISSUE_KEYWORDS` in the backend) - used to populate filter dropdowns, so
 * every option here is a value a real Finding/ClaimCandidate can genuinely
 * have, not a label left over from an earlier fictional demo universe.
 */
export const ISSUE_TAGS: string[] = [
  "change_in_law",
  "capacity_charge_disallowance",
  "fuel_cost_adjustment",
  "carrying_cost",
  "force_majeure",
  "tariff_true_up",
  "roe_tax_gross_up",
];

export const WORKBENCH_MATTER_STATUSES: string[] = [
  "open",
  "drafting",
  "hearing_scheduled",
  "monitoring",
  "closed",
];
